import { call } from 'redux-saga/effects';

import { deleteOutputFilesSaga } from '@sagas/gameChanger/deleteOutputFilesSaga';
import { deleteSpreadsheetsSaga } from '@sagas/savedFilingPeriod/deleteSpreadsheetsSaga';

import { deleteSavedFilingPeriodFilesSaga } from '../deleteSavedFilingPeriodFilesSaga';

export const bulkFileDeleteSaga = function* ({ payload }) {
  if (payload.files.length > 0) {
    yield call(deleteSavedFilingPeriodFilesSaga, { payload: payload.files });
  }

  if (payload.selectedOutputFiles.gameChangerOutputFiles.length > 0) {
    yield call(deleteOutputFilesSaga, {
      payload: {
        templateId: payload.standardTemplateId,
        outputFiles: payload.selectedOutputFiles.gameChangerOutputFiles.map(item => item.id),
      },
    });
  }

  if (payload.spreadsheets.length > 0) {
    yield call(deleteSpreadsheetsSaga, {
      payload: payload.spreadsheets.map(item => ({
        standardTemplateId: item.standardTemplate,
        spreadsheetId: item.id,
      })),
    });
  }
};
